jQuery(document).ready(function ($) {

    if ($(".bloc_hdp").length) {

        document.fonts.ready.then(() => {

            gsap.set($("header"), { opacity : 0 })
            gsap.set($(".bloc_hdp h1"), { opacity : 0 })
            gsap.set($(".bloc_hdp .accroche"), { opacity : 0 })
            gsap.set($(".bloc_hdp .boutons"), { opacity : 0 })



            var HDP = gsap.timeline()

            HDP.to($("header"), {
                opacity : 1,
                duration : 1.0,
                ease: "power1.out",
            })

            HDP.to($("h1"), {
                opacity: 1,
                duration : 0.9,
                ease: "power1.inOut",
            })

            HDP.to($(".bloc_hdp .accroche"), {
                opacity : 1,
                duration : 0.9,
                ease: "power1.out",
            })

            HDP.to($(".bloc_hdp .boutons"), {
                opacity : 1,
                duration : 0.9,
                ease: "power1.out",
            })

        })



    }

})